import { Text, View } from "@-/com.npmjs.react-native";
import Animated, { FadeInUp, FadeOutUp, ReduceMotion } from "@-/com.npmjs.react-native-reanimated";
import { ConfettiBurst } from "@-/dev.improve.haniverse.components.ui.confetti-burst";
import type { ReviewCompletionCelebrationGate } from "#use-review-completion-celebration-gate";

/** Mounted above the deck so changing cards never interrupts the celebration or steals input. */
export function ReviewCompletionCelebration({ gate }: { gate: ReviewCompletionCelebrationGate }) {
  const { celebration } = gate;
  return (
    <View
      className="pointer-events-none absolute inset-0 z-50 overflow-hidden"
      pointerEvents="none"
    >
      <ConfettiBurst key={celebration} />
      <View className="absolute inset-x-0 top-0 items-center px-4 pt-2">
        <Animated.View
          accessibilityLiveRegion="polite"
          accessibilityRole="text"
          className="max-w-full rounded-full border border-stage-familiar/20 bg-background px-4 py-2"
          entering={FadeInUp.duration(220).reduceMotion(ReduceMotion.System)}
          exiting={FadeOutUp.duration(160).reduceMotion(ReduceMotion.System)}
        >
          <Text className="text-center text-sm font-medium text-foreground">
            All caught up! Great work reviewing your characters.
          </Text>
        </Animated.View>
      </View>
    </View>
  );
}
